<!--<ol class="breadcrumb">
<li *ngFor="let breadcrumb of breadcrumbs"
  class="breadcrumb-item">-->
  <!--<a [routerLink]="[breadcrumb.url, breadcrumb.params]">-->



  <div class="breadcrumb">

    @for (breadcrumb of breadcrumbs; track breadcrumb) {
      <div>
        <span>|</span>
        <a (click)="navigate(breadcrumb.Url)">{{translate(breadcrumb.Title)}}</a>
      </div>
    }


    @if (formTitle && formTitle.length > 0) {
      <div>
        <span>|</span>
        <a class="form-title-breadcrumb">{{formTitle}}</a>
      </div>
    }

  </div>


<!--</a>-->
<!--</li>
</ol>-->